<template>
  <div class="p-5 m-5">
<header class="entry-header">
		<h1 class="entry-title">Privacy Policy</h1>			</header><!-- .entry-header -->
<div class="entry-content">
		<p>This statement explains how we collect, use, share and protect your personal information when you use our website.</p>
<h2>Who we are</h2>
<p>The address of our website is <a href="https://beacontour.app/">www.beacontour.app</a>. This is a product created by <a href="https://outsmartis.com/">Outsmartis</a>. Its purpose is to help tourism agencies and managers of interest points to complement touristic experiences. </p>
<h2>What personal data we collect and why we collect them</h2>
<h3>Cookies</h3>
<p style="
    width: 100%;
">Automatic treatment of information for experience optimization.</p>
<h3 style="width: 100%;">Statistics</h3>
<h2>With whom we share our information</h2>
<p>BeaconTour does not share any data with third parties.</p>
<h2>How long do we retain our information?</h2>
<p>If you create a contact request, its information will be indefinitely kept on our side. This is done so that we can can reach back to you. These messages are deleted as soon as they are no longer necessary or relevant.</p>
<h2>What rights do you have about your data?</h2>
<p>If you have create contact requests, you may request an exported file of the personal data we hold about you, including any data you have provided to us. In addition, you may request that any personal data we have about you be deleted. Please note that this does not include data that we are required to maintain for administrative, legal or security purposes.</p>
<h3>Where we send our data</h3>
<p>Statistics on access and interaction with the website are obtained through the Jetpack service. In this way, and not directly sending your data, there is a treatment by this entity. Your privacy policy can be found <a href="https://automattic.com/privacy/">here</a>.</p>
<h2 style="width: 100%;">Additional information</h2>
<h3>How do we protect your information</h3>
<p>We have implemented a regular backup policy. The access to the website is restricted, and protected with secure credentials and changed regularly. The website is regularly updated so that potential known issues are avoided.</p>
<h3>What data breach procedures we have in place</h3>
<p>Any violation of data will be communicated through our various means of communication. In addition, and for those users for whom we have an email or an associated phone number, they will be reported within 24 hours.</p>
<h3>From which the third party does we receive data</h3>
<p>The website is hosted by Bluehost, and its privacy policy can be found <a href="https://www.bluehost.com/terms/privacy-policy">here</a>. There is a statistical data treatment by the Jetpack service, and your privacy policy can be found <a href="https://automattic.com/privacy/">here</a>.</p>
<h3>Automated Decisions and Profiles</h3>
<p style="width: 100%;">No profiles are created for users who interact with the website.</p>
<h3>Changes</h3>
<p>This privacy policy may be updated regularly and, whenever we make changes, these will be posted on our website and you will be alerted that it has been changed.</p>
<h3>Contacts</h3>
<p>If you have questions about our privacy policy, please contact us at <a href="mailto:global@outsmartis.com">global@outsmartis.com</a>.</p>
		</div><!-- .entry-content -->

  </div>
</template>
 
<script>

  export default {

  }
</script> 
 
<style scoped>

</style> 